'use client';
import { isConvertibleColor } from '../../../modules/colors/impl/validators/validators.js';
import { toRGBA } from '../../../modules/colors/impl/toRGBA/toRGBA.js';

const createLightener = (alpha)=>(channel)=>Math.round(channel + (255 - channel) * alpha);
function lighten(color, alpha) {
    if (!isConvertibleColor(color)) {
        return color;
    }
    const { r, g, b, a } = toRGBA(color);
    const light = createLightener(alpha);
    return `rgba(${light(r)}, ${light(g)}, ${light(b)}, ${a})`;
}

export { createLightener, lighten };
//# sourceMappingURL=lighten.js.map
